export const REPORTMONTHLYFORECAST_SEARCH = 'REPORTMONTHLYFORECAST_SEARCH';
export const REPORTMONTHLYFORECAST_PAGE = 'REPORTMONTHLYFORECAST_PAGE';
export const REPORTMONTHLYFORECAST_YEAR = 'REPORTMONTHLYFORECAST_YEAR';
